export class MediaLibrary {
  public id: string;
  public mediaLibraryId: number;
  public uploadedBy: number;
  public folderName: string;
  public fileName: string;
  public uploadedName: string;
  public dimensionX: number;
  public dimensionY: number;
  public altText: string;
  public createdDate: Date;
  public updatedDate: Date;
  public isActive: boolean;
  public caption: string;
  public fileSize: string;
  public fileType: string;
  public detail: string;
  public imageFor: string;
  public activeDiv: boolean;
}



// WEBPACK FOOTER //
// ./src/app/models/mediaLibrary/media-library-model.ts